// extracted by mini-css-extract-plugin
export default {"starRating":"Cs204pIxEeAnJ2MoKGFMUw==","on":"MnpSxll3NkoyDcwik8Zssw==","star":"Ph5kZ+s8LvsmSYBdd58u1Q==","off":"Lue21mJYMvO4b1aNsJZmpg=="};